import { render, staticRenderFns } from "./VerificationRequired.vue?vue&type=template&id=6552e060&lang=pug"
import script from "./VerificationRequired.vue?vue&type=script&lang=js"
export * from "./VerificationRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports